import React, { useEffect, useState } from "react";
import { BASE_URL , REACT_APP_HOMEPAGE } from "../../variables/api";
import { Route, Routes, useNavigate } from "react-router-dom";
import { createBrowserHistory } from "history";

import "./Table.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import { Translate } from "src/utils/Translate";
const Table = (props) => {
  const navigate = useNavigate();
  const history = createBrowserHistory();
  const [ticketsTableData, setTicketsTableData] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [userTableData, setUserTableData] = useState([]);
  const [departmentoptions, setDepartmentOptions] = useState([]);
  const [rolesoptions, setRolesOptions] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [roles, setRoles] = useState([]);
  const initialState = {
    mouseX: null,
    mouseY: null,
  };
  const [state, setState] = useState(initialState);
  const [id, setId] = useState("");
  const handleClick = (event) => {
    event.preventDefault();
    setState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
  };
  const t = new Translate();
  const handleClose = () => {
    setState(initialState);
  };
  useEffect(() => {
    const table = $("#dataTable").DataTable({
      order: [ [5,"desc"],[0,"desc"] ],
    });
  }, [$]);

  useEffect(async () => {
    Swal.showLoading();
    $("#dataTable").DataTable().destroy();
    if (props.config) {
      axios.get(`${BASE_URL}/tickets/getusers.php`).then((res) => {
        setEmployees(res.data.data.assignedepartment);
        setRoles(res.data.data.assignedroles);
        setUserTableData(res.data.data.users);
        props.data(res.data.data.users);
        const departmentOptions = res.data.data.departments?.map((element) => {
          return { value: element.id, label: `${element.department}` };
        });
        const rolesOptions = res.data.data.roles?.map((element) => {
          return { value: element.id, label: `${element.role}` };
        });

        setDepartmentOptions(departmentOptions);
        setRolesOptions(rolesOptions);
        $("#dataTable").DataTable({
          order: [ [5,"desc"],[0,"desc"] ],
        });
        Swal.close();
      });
    } else {
      if (props.departmentid === "") {
        const res = await axios
          .get(`${BASE_URL}/tickets/gettickets.php`)
          .then((res) => {
            setTicketsTableData(res.data.data);
            setFilteredTickets(res.data.data)
            // setFilteredTickets(res.data.data.filter((t)=>t.status == "sent"))
            $("#dataTable").DataTable({
              order: [ [5,"desc"],[0,"desc"] ],
            });
            Swal.close();
          });
      } else {
        if (props.user?.role_id === "1") {
          const res = await axios
            .post(`${BASE_URL}/tickets/getticketsfordepartment.php`, {
              id: props.departmentid,
            })
            .then((res) => {
              setTicketsTableData(res.data.data.tickets);
              setFilteredTickets(res.data.data.tickets)
              $("#dataTable").DataTable({
                order: [ [5,"desc"],[0,"desc"] ],
              });
              Swal.close();
            });
        } else {
          const res = await axios
            .post(`${BASE_URL}/tickets/getticketsfordepartment.php`, {
              id: props.departmentid,
            })
            .then((res) => {
              setTicketsTableData(res.data.data.tickets);
              setFilteredTickets(res.data.data.tickets)
              // setFilteredTickets(res.data.data.tickets.filter((t)=>t.status == "sent"))
              $("#dataTable").DataTable({
                order: [ [5,"desc"],[0,"desc"] ],
              });
              Swal.close();
            });
        }
      }
    }
  }, [props.add]);
  const handleRoleChange = (selectedOptions, id) => {
    let users = [...userTableData];
    users?.map((user) => {
      if (user.id === id) {
        if (selectedOptions === null) {
          user.role_id = "";
        } else {
          user.role_id = selectedOptions.value;
        }
      }
    });
    setUserTableData([...users]);
    props.data([...users]);
  };
  const handleDepartmentChange = (selectedOptions, id) => {
    let users = [...userTableData];
    users?.map((user) => {
      if (user.id === id) {
        user.department_id = { ...selectedOptions };
      }
    });
    setUserTableData([...users]);
    props.data([...users]);
  };
  console.log(userTableData);
  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: 250,
    }),
  };

  const handelFilterChange = (e)=>{
    $("#dataTable").DataTable().clear();
       let tempTickets = [...ticketsTableData];
       tempTickets = tempTickets.filter((t)=> t.status == e.target.value) ;
       setFilteredTickets(tempTickets)
       $("#dataTable").DataTable();
  }

  return (
    <>
    {/* <div class="form-group col-3">
    <label for="exampleFormControlSelect1">Status </label>
    <select onChange={(e)=>{ handelFilterChange(e)}} class="form-control" id="exampleFormControlSelect1">
      <option value="sent">Sent</option>
      <option value="Being Reviewed">Being Reviewed</option>
      <option value="Completed">Completed</option>
      
    </select>
  </div> */}
      <div className="table-responsive-sm">
        <table id="dataTable" className="table table-striped table-sm">
          <thead>
            {props.config ? (
              <tr className="tr">
                <th className="th">{t.translate("ID")}</th>
                <th className="th">{t.translate("Name")}</th>
                <th className="th">{t.translate("Email")}</th>
                <th className="th">{t.translate("Job Title")} </th>
                <th className="th">{t.translate("Role")}</th>
                <th className="th">{t.translate("Department")}</th>
              </tr>
            ) : (
              <tr className="tr">
                <th className="th">{t.translate("ID")}</th>
                <th className="th">{t.translate("Ticket Owner")}</th>
                <th className="th">{t.translate("Ticket Owner Type")}</th>
                <th className="th">{t.translate("Subject")}</th>
                <th className="th">{t.translate("Date")}</th>
                <th className="th">{t.translate("Status")}</th>
                <th className="th">{t.translate("Department")}</th>
                <th className="th">{t.translate("Actions")}</th>
              </tr>
            )}
          </thead>
          <tbody style={props.style}>
            {props.config && roles
              ? userTableData?.map((dt, index) => {
                  return (
                    <tr key={dt.id} className="tr" id={dt.id}>
                      <td className="td">{dt.id}</td>
                      <td className="td">{dt.displayname}</td>
                      <td className="td">{dt.username}</td>
                      <td className="td">{dt.jobtitle}</td>
                      <td className="td">
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          
                          defaultValue={roles[index]}
                          options={rolesoptions}
                          isClearable
                          onChange={(selectedOption) => {
                            handleRoleChange(selectedOption, dt.id);
                          }}
                        />
                      </td>
                      <td className="td">
                        <Select
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          
                          isMulti
                          isClearable
                          defaultValue={employees
                            ?.find((f) => f.id === dt.id)
                            ?.departments?.map((empdepartment) => {
                              return {
                                value: empdepartment.id,
                                label: empdepartment.department,
                              };
                            })}
                          onChange={(selectedOption) => {
                            handleDepartmentChange(selectedOption, dt.id);
                          }}
                          options={departmentoptions}
                          isDisabled
                        />
                      </td>
                    </tr>
                  );
                })
              : filteredTickets?.map((dt) => {
                  if (
                    props.departmentid === "" &&
                    !(props.user?.role_id === "1")
                  ) {
                    return (
                      <tr key={dt.id} className="tr" id={dt.id}>
                        <td className="td">{dt.id}</td>
                        <td className="td">{dt.displayname}</td>
                        <td className="td">
                          {dt.username?.search("ivy") === -1
                            ? "Parent"
                            : "Employee"}
                        </td>
                        <td className="td">{dt.subject}</td>
                        <td className="td">{dt.date}</td>
                        <td className="td">{dt.status}</td>
                        <td className="td">{dt.department}</td>
                        <td className="td">
                          <a
                            className="btn btn-primary"
                            target="_blanck"
                            href={`${REACT_APP_HOMEPAGE}/departmentticket/${dt.id}`}
                            
                          >
                            {t.translate("View")}
                          </a>
                        </td>
                      </tr>
                    );
                  } else {
                    return (
                      <tr key={dt.id} id={dt.id}>
                        <td>{dt.id}</td>
                        <td>{dt.displayname}</td>
                        <td>
                          {dt.username.search("ivy") === -1
                            ? "Parent"
                            : "Employee"}
                        </td>
                        <td>{dt.subject}</td>
                        <td>{dt.date}</td>
                        <td>{dt.status}</td>
                        <td className="td">{dt.department}</td>
                        <td>
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              navigate(`/departmentticket/${dt.id}`);
                            }}
                          >
                            {t.translate("View")}
                          </button>
                        </td>
                      </tr>
                    );
                  }
                })}
          </tbody>
        </table>
      </div>
    </>
  );
};
export default Table;
